import React, { useState } from "react";
import { Warning } from "@material-ui/icons";

export default function CancelModal({ setOpen, onConfirm }) {
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (!reason.trim()) {
      setError("O motivo do cancelamento é obrigatório.");
      return;
    }
    setError("");
    setIsLoading(true);
    try {
      await onConfirm(reason);
    } finally {
      setIsLoading(false);
    }
  };

  const handlerDismiss = () => {
    setOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "8px",
          padding: "32px",
          minWidth: "320px",
          boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
          textAlign: "center"
        }}
      >
        <Warning style={{ color: "#f42a3f", fontSize: 48, marginBottom: 16 }} />
        <h2>Cancelar Assinatura</h2>
        <p>Tem certeza que deseja cancelar a assinatura?</p>
        <div style={{ margin: "16px 0" }}>
          <textarea
            placeholder="Motivo do cancelamento"
            value={reason}
            onChange={e => setReason(e.target.value)}
            rows={3}
            style={{
              width: "100%",
              borderRadius: 4,
              border: "1px solid #ccc",
              padding: 8,
              resize: "vertical"
            }}
            disabled={isLoading}
          />
          {error && (
            <div style={{ color: "#f42a3f", fontSize: 13, marginTop: 4 }}>
              {error}
            </div>
          )}
        </div>
        <div style={{ marginTop: 24, display: "flex", justifyContent: "center", gap: 16 }}>
          <button
            className="btn btn-secondary"
            onClick={() => handlerDismiss()}
            disabled={isLoading}
          >
                        Não
          </button>
          <button
            className="btn btn-danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Cancelando..." : "Sim, cancelar"}
          </button>
        </div>
      </div>
    </div>
  );
}